export const OrderState = {
	none: 0,
	is_external: 1,
	is_external_approved: 2,
};

export const OrderExternalNotApprovedColor = 'rgba(10, 150, 200)';
